module.exports = __webpack_public_path__ + "img/cd_1_front.25db7647.jpg";